import { useEffect } from 'react'
import PropTypes from 'prop-types'

import { useShopContext } from 'src/pages/main/shop/contexts/ShopContext'
import MagnifyingGlassButton from 'src/assets/img/shop/magnifying_glass.png'

import ShopBlock from 'src/pages/main/shop/components/ShopBlock'
import PurchaseButton from 'src/pages/main/shop/components/ShopDiamondTab/PurchaseButton'
import ExchangeExplanatoryModal from 'src/pages/main/shop/components/ShopExchangeTab/ExchangeExplanatoryModal'

const ShopTierItem = ({ item, handleChangeTab }) => {
  const { closeModal, setModalContent, setButtons, setTitle } = useShopContext()

  useEffect(() => {
    setButtons([
      {
        label: 'OK',
        onClick: closeModal
      }
    ])
    setTitle('詳細')
  }, [])

  const handleSelect = () => {
    setModalContent(<ExchangeExplanatoryModal description={item.description} />)
  }

  return (
    <ShopBlock boxShadow>
      <div className="relative flex gap-1 items-center justify-between pl-2 py-2">
        <div className="flex items-center">
          <img
            src={item.image}
            alt={item.item_name}
            className="rounded-md w-[4.4375rem] h-[4.125rem] border border-light-pinkish"
          />

          {item.description && (
            <button className="absolute top-[3.8rem] left-[4.3rem] z-10" onClick={handleSelect}>
              <img src={MagnifyingGlassButton} className="w-5" />
            </button>
          )}
        </div>
        <div className="flex flex-col w-24 xs:w-40 text-bubblegum-pink font-black">
          <p className="max-w-full overflow-hidden truncate">{item.item_name}</p>
          <p
            className="text-xs"
            style={{
              textShadow: '-1px 0 white, 1px 0 white, 0 1px white, 0 -1px white',
              filter: 'drop-shadow(#FFAEDA 0px 2px 0px)'
            }}
          >
            交換ポイント
          </p>
          <p className="font-normal">{item.material_points}pt</p>
        </div>
        <PurchaseButton text="交換" onClick={handleChangeTab} disabled={false} />
      </div>
    </ShopBlock>
  )
}

ShopTierItem.propTypes = {
  item: PropTypes.object,
  handleChangeTab: PropTypes.func
}

export default ShopTierItem
